import React, { createContext, useContext, useState } from "react";

// Definisci il tipo di stato che desideri condividere
interface AppContextProps {
  //header e footer
  isHeaderAndFooterEnabled: boolean;
  setIsHeaderAndFooterEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  //TODO: scriba capire se serve dare altre variabili da gestire
  isScribaEnabled: boolean;

  isScribaSelected: boolean;
  isScribaWriting: boolean;
  isScribaEntering: boolean;
  isScribaLooped: boolean;

  reactionBoxState: boolean;
  qrBoxState: boolean;

    setIsScribaSelected: React.Dispatch<React.SetStateAction<boolean>>;
    setIsScribaWriting: React.Dispatch<React.SetStateAction<boolean>>;
    setIsScribaEntering: React.Dispatch<React.SetStateAction<boolean>>;
    setIsScribaLooped: React.Dispatch<React.SetStateAction<boolean>>;
  setIsScribaEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  setReactionBoxState: React.Dispatch<React.SetStateAction<boolean>>;
  setQrBoxState: React.Dispatch<React.SetStateAction<boolean>>;

  scribaTextITA: string;
  scribaTextENG: string;
  setScribaTextITA: React.Dispatch<React.SetStateAction<string>>;
  setScribaTextENG: React.Dispatch<React.SetStateAction<string>>;

  isButtonLayerVisible: boolean;
  isButtonLayerVisibleHome: boolean;
  setIsButtonLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setIsButtonLayerVisibleHome: React.Dispatch<React.SetStateAction<boolean>>;

  isSecondButtonLayerVisible: boolean;
  isSecondButtonLayerVisibleHome: boolean;
  setIsSecondButtonLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSecondButtonLayerVisibleHome: React.Dispatch<React.SetStateAction<boolean>>;

  userName: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;

  // Aggiungi altri stati o funzioni necessarie
}

interface AppProviderProps {
  children: React.ReactElement;
}

// Crea il contesto
const AppContext = createContext<AppContextProps | undefined>(undefined);

// Crea il provider
export const AppContextProvider: React.FC<AppProviderProps> = ({
  children,
}) => {
  const [isHeaderAndFooterEnabled, setIsHeaderAndFooterEnabled] =
    useState(true);

  //TODO: gestione stato scriba
  const [isScribaEnabled, setIsScribaEnabled] = useState(true);
  //const [scribaState, setScribaState] = useState("intro");
  const [isScribaSelected, setIsScribaSelected] = useState(false);
  const [isScribaWriting, setIsScribaWriting] = useState(false);
  const [isScribaEntering, setIsScribaEntering] = useState(false);
  const [isScribaLooped, setIsScribaLooped] = useState(false);

  const [reactionBoxState, setReactionBoxState] = useState(false);
  const [qrBoxState, setQrBoxState] = useState(false);
  const [scribaTextITA, setScribaTextITA] = useState("");
  const [scribaTextENG, setScribaTextENG] = useState("");
  //nei vari onClick dei buttons gestirò il mettere cosa a true e cosa a false.
  const [isButtonLayerVisible, setIsButtonLayerVisible] = useState(false);
  const [isButtonLayerVisibleHome, setIsButtonLayerVisibleHome] = useState(false);
  const [isSecondButtonLayerVisible, setIsSecondButtonLayerVisible] =  useState(false);
  const [isSecondButtonLayerVisibleHome, setIsSecondButtonLayerVisibleHome] =  useState(false);


  const [userName, setUserName] = useState("");

  return (
    <AppContext.Provider
      value={{
        isHeaderAndFooterEnabled: isHeaderAndFooterEnabled,
        setIsHeaderAndFooterEnabled: setIsHeaderAndFooterEnabled,
        isScribaEnabled: isScribaEnabled,

          isScribaSelected: isScribaSelected,
          isScribaWriting: isScribaWriting,
          isScribaEntering: isScribaEntering,
          isScribaLooped: isScribaLooped,

        reactionBoxState: reactionBoxState,
        qrBoxState: qrBoxState,

        setIsScribaSelected:setIsScribaSelected,
          setIsScribaWriting: setIsScribaWriting,
          setIsScribaEntering:setIsScribaEntering,
          setIsScribaLooped:setIsScribaLooped,
        setIsScribaEnabled: setIsScribaEnabled,

        setReactionBoxState: setReactionBoxState,
        setQrBoxState: setQrBoxState,

        scribaTextITA: scribaTextITA,
        setScribaTextITA: setScribaTextITA,
        scribaTextENG: scribaTextENG,
        setScribaTextENG: setScribaTextENG,
        isButtonLayerVisible: isButtonLayerVisible,
        isButtonLayerVisibleHome: isButtonLayerVisibleHome,
        setIsButtonLayerVisible: setIsButtonLayerVisible,
        setIsButtonLayerVisibleHome: setIsButtonLayerVisibleHome,
        isSecondButtonLayerVisible: isSecondButtonLayerVisible,
        isSecondButtonLayerVisibleHome: isSecondButtonLayerVisibleHome,
        setIsSecondButtonLayerVisible: setIsSecondButtonLayerVisible,
        setIsSecondButtonLayerVisibleHome: setIsSecondButtonLayerVisibleHome,

        userName: userName,
        setUserName: setUserName,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Hook personalizzato per consumare il contesto
export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error(
      "useAppContext deve essere utilizzato all'interno di AppContextProvider",
    );
  }

  return context;
};
